import { isUrl, isUrlSingleDomain } from '@kentik/ui-shared/validators/url';
import htmlSanitary from './htmlSanitary';

const message = 'Enter a valid URL';

// URL validation using existing sanitary rules for XSS protection
const isIPv6Url = (value) => {
  try {
    const { hostname } = new URL(value);
    return hostname.includes(':');
  } catch {
    return false;
  }
};

const isUrlSafe = (value, options = {}) => {
  if (!value) {
    return true; // Allow empty values
  }

  // First check if it's a valid URL format
  if (isIPv6Url(value) ? !isUrlSingleDomain(value) : !isUrl(value)) {
    return false;
  }

  // Skip htmlSanitary for IPv6 URLs
  if (!options.skipHtmlSanitary && !htmlSanitary.fn(value)) {
    return false;
  }

  // Additional check for dangerous schemes that htmlSanitary doesn't catch
  // eslint-disable-next-line no-script-url
  const dangerousSchemes = ['javascript:', 'data:', 'vbscript:', 'file:', 'about:'];
  const lowerValue = value.toLowerCase().trim();

  if (dangerousSchemes.some((scheme) => lowerValue.startsWith(scheme))) {
    return false;
  }

  return true;
};

export const urlSingleDomain = {
  message,
  fn: (value, options) => isUrlSingleDomain(value, options) && isUrlSafe(value)
};

export const safeURL = {
  message: 'Enter a valid and safe URL',
  fn: isUrlSafe
};

export const unsanitaryURL = {
  message: 'Enter a valid URL',
  fn: (value) => isUrlSafe(value, { skipHtmlSanitary: true })
};

export default {
  message: 'Enter a valid URL',
  fn: (value) => Boolean(isUrl(value)) && isUrlSafe(value)
};
